if (!customElements.get('bn-customer-videos')) {
  customElements.define('bn-customer-videos', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const track = this.querySelector('.bn-stories__track');
      const dialog = this.querySelector('dialog');
      const video = dialog.querySelector('video');
      let opener;
      const viewport = this.querySelector('.bn-stories__viewport');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let distance = 0;
      let pauseUntil = 0;
      let pointer;
      let suppressClick = false;
      let previousTime;
      let autoPosition = 0;
      const pause = () => { pauseUntil = performance.now() + 800; };
      const update = () => {
        track.querySelectorAll('[data-story-copy]').forEach(node => node.remove());
        distance = 0;
        const originals = [...track.children];
        if (motion.matches || !originals.length) return;
        const gap = parseFloat(getComputedStyle(track).gap);
        distance = originals.reduce((sum, card) => sum + card.getBoundingClientRect().width + gap, 0);
        if (!distance) return;
        for (let i = 0; i < Math.ceil(viewport.clientWidth / distance) + 1; i++) {
          originals.forEach(card => {
            const clone = card.cloneNode(true);
            clone.dataset.storyCopy = '';
            clone.setAttribute('aria-hidden', 'true');
            clone.removeAttribute('data-shopify-editor-block');
            clone.querySelectorAll('button').forEach(button => button.tabIndex = -1);
            track.append(clone);
          });
        }
        viewport.scrollLeft %= distance;
      };
      const animate = time => {
        const elapsed = previousTime === undefined ? 0 : Math.min(time - previousTime, 64);
        previousTime = time;
        if (distance && !motion.matches && !document.hidden && !pointer && time >= pauseUntil &&
            !viewport.matches(':hover, :focus-within') && !dialog.open) {
          autoPosition = (autoPosition + elapsed * 0.024) % distance;
          viewport.scrollLeft = autoPosition;
        } else {
          autoPosition = viewport.scrollLeft;
        }
        this.frame = requestAnimationFrame(animate);
      };
      viewport.addEventListener('wheel', pause, { ...options, passive: true });
      viewport.addEventListener('keydown', pause, options);
      viewport.addEventListener('pointerdown', event => {
        pause();
        suppressClick = false;
        if (event.button !== 0) return;
        pointer = { id: event.pointerId, type: event.pointerType, x: event.clientX, scroll: viewport.scrollLeft, dragged: false };
      }, options);
      viewport.addEventListener('pointermove', event => {
        if (!pointer || pointer.type !== 'mouse' || event.pointerId !== pointer.id) return;
        const delta = event.clientX - pointer.x;
        if (!pointer.dragged && Math.abs(delta) < 6) return;
        if (!pointer.dragged) {
          pointer.dragged = true;
          viewport.setPointerCapture(event.pointerId);
          viewport.classList.add('is-dragging');
        }
        event.preventDefault();
        viewport.scrollLeft = pointer.scroll - delta;
      }, options);
      const release = event => {
        if (!pointer || event.pointerId !== pointer.id) return;
        suppressClick = pointer.dragged;
        pointer = undefined;
        viewport.classList.remove('is-dragging');
        if (viewport.hasPointerCapture(event.pointerId)) viewport.releasePointerCapture(event.pointerId);
        pause();
      };
      window.addEventListener('pointerup', release, options);
      window.addEventListener('pointercancel', release, options);
      viewport.addEventListener('lostpointercapture', release, options);
      viewport.addEventListener('dragstart', event => event.preventDefault(), options);
      viewport.addEventListener('click', event => {
        if (!suppressClick) return;
        suppressClick = false;
        event.preventDefault();
        event.stopPropagation();
      }, { ...options, capture: true });
      motion.addEventListener('change', update, options);
      this.addEventListener('click', event => {
        const watch = event.target.closest('[data-video]');
        if (watch) {
          opener = watch;
          video.src = watch.dataset.video;
          dialog.showModal();
          this.classList.add('is-watching');
          video.play().catch(() => {});
        }
        if (event.target.closest('.bn-stories__close') || event.target === dialog) dialog.close();
      }, options);
      dialog.addEventListener('close', () => {
        this.classList.remove('is-watching');
        video.pause();
        video.removeAttribute('src');
        video.load();
        opener?.focus({ preventScroll: true });
      }, options);
      this.resize = new ResizeObserver(update);
      this.resize.observe(viewport);
      update();
      this.frame = requestAnimationFrame(animate);
    }
    disconnectedCallback() {
      this.querySelector('video')?.pause();
      this.events?.abort();
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
